import { render, staticRenderFns } from "./PatientData.vue?vue&type=template&id=39ce58c3&scoped=true"
import script from "./PatientData.vue?vue&type=script&lang=js"
export * from "./PatientData.vue?vue&type=script&lang=js"
import style0 from "./PatientData.vue?vue&type=style&index=0&id=39ce58c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ce58c3",
  null
  
)

export default component.exports